import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import LayoutProvider from 'layouts';
import NotificationProvider from 'notifications';
import { Tooltip } from 'react-tooltip';
import RoutesProvider from 'router';
import queryClient from "./queryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <RoutesProvider>
          <LayoutProvider />
          <Tooltip id="global-tooltip" />
        </RoutesProvider>
      </NotificationProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
